import NetworkHandler from 'utils/network';
import config from 'config';

function getBusinessPlan(params) {
    return NetworkHandler.post(`${config.getUrl('business_plan')}/find`, {
        ...params,
    });
}

function updateBusinessPlan(params) {
    return NetworkHandler.put(`${config.getUrl('business_plan')}/update`, {
        ...params,
    });
}

function importFile(params) {
    return NetworkHandler.post(`${config.getUrl('business_plan')}/import-file`, params, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

function deleteBusinessPlan(params) {
    return NetworkHandler.put(`${config.getUrl('business_plan')}/delete`, {
        ...params,
    });
}

export default {
    getBusinessPlan,
    updateBusinessPlan,
    importFile,
    deleteBusinessPlan,
};
